import { MongoObservable } from 'meteor-rxjs';
import { AggregatedJobMatrixJob } from 'server/shared/models/aggregatedJobMatrixJobs';

export const AggregatedJobMatrixJobs =
  new MongoObservable.Collection<AggregatedJobMatrixJob>(
    'aggregatedJobMatrixJobs',
  );
